<template>
  <div class="skeleton-vacancy-card">
    <div class="skeleton-header">
      <div class="skeleton-logo shimmer"></div>

      <div class="skeleton-company">
        <div class="skeleton-line company shimmer"></div>
        <div class="skeleton-line specific shimmer"></div>
      </div>

      <div class="skeleton-like shimmer"></div>
    </div>

    <div class="skeleton-image shimmer">
      <div class="skeleton-city shimmer"></div>
    </div>

    <div class="skeleton-preview">
      <div class="skeleton-preview-bg shimmer"></div>

      <div class="skeleton-overlay">
        <div class="skeleton-title shimmer"></div>
        <div class="skeleton-title second shimmer"></div>
        <div class="skeleton-desc shimmer"></div>
        <div class="skeleton-desc medium shimmer"></div>
        <div class="skeleton-desc short shimmer"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.skeleton-vacancy-card {
  width: 375px;
  height: 328px;
  border-radius: 17px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: rgb(39, 39, 39);
  border: 0.1px solid rgb(58, 58, 58);
}

[data-theme="light"] .skeleton-vacancy-card {
  background: #ffffff;
  border: 0.1px solid rgb(225, 225, 225);
}

.skeleton-header {
  height: 58px;
  width: 100%;
  padding: 12px 16px 12px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: relative;
}

.skeleton-logo {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 10px;
}

.skeleton-company {
  display: flex;
  flex-direction: column;
  gap: 7px;
  flex: 1;
  min-width: 0;
}

.skeleton-line {
  height: 9px;
  border-radius: 999px;
}

.skeleton-line.company {
  width: 120px;
}

.skeleton-line.specific {
  width: 82px;
  height: 7px;
}

.skeleton-like {
  width: 18px;
  height: 14px;
  border-radius: 8px;
  position: absolute;
  right: 16px;
}

.skeleton-image {
  width: 100%;
  height: 170px;
  position: relative;
  flex-shrink: 0;
}

.skeleton-city {
  position: absolute;
  top: 10px;
  right: 16px;
  width: 76px;
  height: 18px;
  border-radius: 18px;
}

.skeleton-preview {
  position: relative;
  flex: 1;
  width: 100%;
  overflow: hidden;
}

.skeleton-preview-bg {
  position: absolute;
  inset: -5%;
  width: 110%;
  height: 110%;
  filter: blur(10px);
  opacity: 0.65;
}

.skeleton-overlay {
  position: absolute;
  top: 12px;
  left: 14px;
  right: 14px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.skeleton-title {
  width: 72%;
  height: 13px;
  border-radius: 999px;
}

.skeleton-title.second {
  width: 46%;
}

.skeleton-desc {
  width: 92%;
  height: 8px;
  border-radius: 999px;
  margin-top: 3px;
}

.skeleton-desc.medium {
  width: 76%;
  margin-top: 0;
}

.skeleton-desc.short {
  width: 54%;
  margin-top: 0;
}

.shimmer {
  position: relative;
  overflow: hidden;
  background: var(--skeleton-bg, #343434);
}

[data-theme="light"] .shimmer {
  background: #ececec;
}

.shimmer::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--skeleton-shimmer, rgba(255, 255, 255, 0.12)) 50%,
    transparent 100%
  );
  animation: shimmerMove 1.35s infinite;
}

[data-theme="light"] .shimmer::after {
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.7) 50%,
    transparent 100%
  );
}

@keyframes shimmerMove {
  100% {
    transform: translateX(100%);
  }
}

@media (max-width: 430px) {
  .skeleton-vacancy-card {
    width: 100%;
    height: 328px;
  }
}
</style>